import styled from "styled-components";

export const ParentStyled = styled.main`
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: var(--vh);
  overflow: auto;
  padding-bottom: 0;

  @media all and (min-width: 992px) and (orientation: landscape) {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-bottom: 40px;
  }
`;

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 540px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  margin: 0 auto;

  @media all and (min-width: 992px) and (orientation: landscape) {
    flex-grow: 1;
  }
`;

export const SliderContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: -16px;
  margin-top: ${props => props.isWeb ? "50px" : "0"};
  width: calc(100% + 32px);
  flex: 1;  

  .swiper {
    padding-bottom: 34px;

    &-creative {
      overflow: visible;
      padding: 0;
    }
  }
`;

export const SliderSlidesCountStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  padding: 0;
  margin-bottom: 16px;
`;

export const SliderSlidesCountValueStyled = styled.p`
  font-size: 12px;
  font-weight: 300;
  line-height: 1.67;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
`;

export const ImageContextStyled = styled.div`
  &.disabled {
    opacity: 0.5;
  }
`;

export const ImageContextInputStyled = styled.input`
  appearance: none;
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;
  left: -9999px;
  z-index: -10;

  &:checked + label {
    color: #234af1;

    &::after {
      border-color: #234af1;
      background-color: #234af1;
    }

    &::before {
      content: "";
      display: block;
      width: 7px;
      height: 12px;
      position: absolute;
      left: 6px;
      top: 1px;
      transform: rotate(45deg);
      box-sizing: border-box;
      border: 2px solid #1a1b1d;
      border-top: none;
      border-left: none;
      z-index: 10;
    }
  }
`;

export const ImageContextLabelStyled = styled.label`
  position: relative;
  font-size: 14px;
  color: rgb(255 255 255 / 70%);
  padding-left: 26px;

  &::after {
    content: "";
    display: block;
    width: 18px;
    height: 18px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #979797;
  }
`;

export const BtnsGroupStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  padding: 0;

  .ios && {
      margin-bottom: 30px;
    }
`;

export const ButtonStyled = styled.button`
  position: relative;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: none;
  position: relative;
  height: 48px;
  width: 100%;
  margin: 0;

  .touch-effect {
    border-radius: 100px;
  }

  &[disabled] {
    opacity: 0.5;

    .touch-effect {
        display: none;
    }
  }

  .arrow-more {
    left: ${props => props.svgPos === "left" ? "16px" : "auto"};
    right: ${props => props.svgPos === "right" ? "16px" : "auto"};
  }

  .social-icon {
    width: 21px;
    height: 21px;
    border-radius: 0;
    margin-right: 8px;
  }

  ${props => props.saveBtn && `
  @keyframes shakeArrow {
    0% {
      transform: translateY(-3px);
    }
    50% {
      transform: translateY(3px);
    }

    100% {
      transform: translateY(-3px);
    }
  }

    svg {
      width: 14px;
      fill: #fff;
      margin-right: 10px;

      path {
        animation: shakeArrow 800ms infinite ease-out;
      }
    }
  `}

  ${props => props.animate && `
    margin-left: 16px;

    .arrow-more {
      width: 14px;
      fill: #fff;
      animation: shake2 800ms infinite ease-out;
      // margin-left: 10px;
    }

    @keyframes shake2 {
      0% {
        transform: translateX(-4px);
      }
      50% {
        transform: translateX(4px);
      }

      100% {
        transform: translateX(-4px);
      }
    }
  `}

  ${props => props.isIconStyles && `
    svg {
      margin-left: 0;
      margin-right: 10px;
    }
  `}

  ${props => props.full && `
    font-weight: bold;
    color: #fff;
    background: rgb(255, 98, 165);

    &[disabled] {
      color: #fff;
      background: rgb(255, 98, 165);

    }
  `}

  ${props => props.transparent && `
    color: rgb(255, 98, 165);
    border: 2px solid rgb(255, 98, 165);
    background-color: transparent;

    &[disabled] {
      color: rgb(255, 98, 165);
      border: 2px solid rgb(255, 98, 165);
      background-color: transparent;
    }
  `}

  &.btn-video {
    justify-content: center;

    .social-icon {
      margin-right: 0;
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      object-fit: contain;
    }

    .arrow-more {
      position: absolute;
      top: 50%;
      right: 20px;
      animation: shake3 800ms infinite ease-out;
    }

    @media all and (max-width: 375px) {
      .social-icon {
        left: 10px;
      }

      .arrow-more {
        right: 12px;
      }
    }

    @media all and (max-width: 350px) {
      .social-icon,
      .arrow-more {
        display: none;
      }
    }

    @keyframes shake3 {
      0% {
        transform: translateX(-4px) translateY(-50%);
      }
      50% {
        transform: translateX(4px) translateY(-50%);
      }

      100% {
        transform: translateX(-4px) translateY(-50%);
      }
    }
  }
`;

export const SpinnerStyled = styled.span`
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-top-color: transparent;
  animation: rotate 1.5s linear infinite;

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
`

export const ButtonChooseContainerStyled = styled.div`
  margin-right: 16px;
  
  button {
    border: 2px solid rgb(255, 98, 165);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    padding: 12px;
    font-size: 14px;
    font-weight: bold;
    color: rgb(255, 98, 165);
    text-transform: uppercase;
    background-color: transparent;
    
    .touch-effect {
      border-radius: 100%;
    }
  }
`;

export const BackButtonStyled = styled.button`
  position: absolute;
  width: 20px;
  background: none;
  left: 8px;
`;